import {useTranslation} from "react-i18next";
import {useEffect, useRef, useState} from "react";
import NavBreadcrum from "components/NavBreadcrum";
import navs from "./navs";
import axiApi from "ApiCaller";
import ButtonsActions from "views/utils/buttonsActions";
import TopBarActions from "components/TopBarActions";
import PrevZones from "./route-zones/PrevZones";
import TableZones from "./route-zones/TableZones";
import FormZone from "./route-zones/FormZone";
import {ZoneModel} from "site-apps/distribution/zones/ZoneModels";
import {SwalAlertClass, SwalAlertChoice} from "core/swalClass";
import LoaderSpinner from "context/LoaderSpinner";
import FilterModel from "components/FilterModel";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import {PagerModel} from "components/paginator/PaginationModel";
import OrderingModel from "components/ordering/OrderingModel";
import ItemsModel from "core/itemsModel";

const ViewZones = () => {
    const {t: _Tr} = useTranslation("routes");
    const {t: _Tt} = useTranslation("tables");
    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
    document.title = _Tr("labels.areas");
    const [buttonsTB, setButtonsTB] = useState({
        ...new ButtonsActions(),
        title: document.title,
    });

    const bread = [
        {name: _Tr("labels.route-management"), url: "/route-management", current: false},
        {name: _Tr("labels.areas"), current: true},
    ];
    const items = useRef(new ItemsModel());
    const filters = useRef(new FilterModel());
    const pagerModelRef = useRef(new PagerModel());
    const orderingRef = useRef(new OrderingModel());

    const [item, setItem] = useState({...ZoneModel});
    const [showPrev, setShowPrev] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [itemsShown, setItemsShown] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [checkAll, setCheckAll] = useState(false);

    const headersTable = [
        {name: _Tt("common.name"), attr: 0, direction: "asc", active: true, default: true},
        {name: _Tt("common.description"), attr: 1, direction: "asc", active: false},
    ];

    useEffect(() => {
        let buttons = {...buttonsTB};
        buttons.title = document.title;
        buttons.add.active = true;
        buttons.add.onClick = clickAdd;
        buttons.add.disabled = false;
        buttons.edit.active = true;
        buttons.edit.disabled = true;
        buttons.edit.onClick = clickEdit;
        buttons.delete.active = true;
        buttons.delete.onClick = clickDelete;
        buttons.delete.disabled = true;

        setButtonsTB(buttons);
        pagerModelRef.current.active = true;
        pagerModelRef.current.handleCallApi = () => {
            getZones();
        };
        orderingRef.current.setHeaders(headersTable);
        orderingRef.current.applyOrder = () => getZones();
        items.current.setItem = setItem;
        items.current.setShowPrev = setShowPrev;
        items.current.item = ZoneModel;

        getGetZones();
    }, []);

    filters.current.filter = () => {
        pagerModelRef.current.paging.page = 1;
        getZones();
    };

    const getGetZones = () => {
        setIsLoading(true);
        axiApi
            .get("/api/distribution/zone/list/")
            .then((resp) => {
                items.current.showed = [...resp.data.items];
                setItemsShown([...resp.data.items]);
                if (resp.data.pager) {
                    pagerModelRef.current.paging.update(resp.data.pager);
                }
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const getZones = () => {
        setIsLoading(true);
        axiApi
            .post(`/api/distribution/zone/list/`, filters.current.chosen, {
                params: {...pagerModelRef.current.paging.getParams(), ...orderingRef.current.getParams()},
            })
            .then((resp) => {
                items.current.setShowed(resp.data.items);
                setItemsShown([...resp.data.items]);
                if (resp.data.pager) {
                    pagerModelRef.current.paging.update(resp.data.pager);
                }
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const clickAdd = () => {
        setItem({...ZoneModel});
        setShowForm(true);
    };

    const clickEdit = () => {
        if (!items.current.showed.length) {
            return false;
        }
        let itemSelected = items.current.showed.find((item) => item.id === items.current.chosen[0]);
        setItem({...itemSelected});
        setShowForm(true);
    };

    const AlertQuestion = new SwalAlertChoice({
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
    });

    const clickDelete = () => {
        AlertQuestion.warning("Borrar", `Se borraran los ${items.current.chosen.length} seleccionados`).then((resp) => {
            if (resp.isConfirmed) {
                setIsLoading(true);
                let ids = items.current.getChosenIds();
                axiApi
                    .delete(`/api/distribution/zone/delete/`, {data: {ids: ids}})
                    .then((resp) => {
                        if (resp.data.status) {
                            Alert.success("Confirmado", "Se han eliminado correctamente");
                            getZones();
                            items.current.checkBoxes.forEach((checkbox) => {
                                if (checkbox) checkbox.checked = false;
                            });
                        }
                    })
                    .catch((error) => {
                        console.error("Error al enviar la solicitud:", error);
                    })
                    .finally(() => {
                        let buttons = {...buttonsTB};
                        buttons.edit.disabled = true;
                        buttons.delete.disabled = true;
                        setButtonsTB(buttons);
                        items.current.clearChosen();
                        setShowPrev(false);
                        setIsLoading(false);
                    });
            }
        });
    };

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <TopBarActions actions={buttonsTB} filtersRef={filters} />
            <TopBarPagination pagerModel={pagerModelRef.current} stickyTopValue="125px" chosen={items.current.chosen} />
            <div className="row">
                <div className={showPrev ? "col-md-9" : "col-md-12"}>
                    <LoaderSpinner isLoading={isLoading}>
                        <TableZones
                            itemsShow={itemsShown}
                            setItemsShow={setItemsShown}
                            items={items}
                            checkAll={checkAll}
                            setCheckAll={setCheckAll}
                            buttonsTB={buttonsTB}
                            setButtonsTB={setButtonsTB}
                            orderingRef={orderingRef}
                        />
                    </LoaderSpinner>
                </div>
                {showPrev ? (
                    <div className="col-md-3">
                        <PrevZones zone={item} showPreview={showPrev} />
                    </div>
                ) : (
                    <> </>
                )}
            </div>

            <FormZone showForm={showForm} setShowForm={setShowForm} item={item} items={items} setItemsShown={setItemsShown} />
        </>
    );
};

export default ViewZones;
